import React from "react";
import Card from "@mui/material/Card";
import Footer from "../../../components/Footer";
import MDBox from "../../../components/MDBox";
import DashboardNavbar from "../../../components/Navbars/DashboardNavbar";
import DashboardLayout from "../../../components/LayoutContainers/DashboardLayout";
import DataTable from "../../../components/DataTable/DataTable";
import {API_URL} from "../../../config";
import useProducts from "./useProducts";

const Products = () => {
    const {actions, filters, renderStatusChip} = useProducts();

    return (
        <DashboardLayout>
            <DashboardNavbar/>
            <MDBox pt={2} pb={3}>
                <MDBox mb={3}>
                    <Card>
                        <DataTable
                            endpoint={`${API_URL}/products`}
                            title="Productos"
                            description="Administrar los productos de la farmacia."
                            sortBy="name"
                            sortDirection="asc"
                            filter={false}
                            actions={actions}
                            colData={[
                                {
                                    name: 'id',
                                    label: 'ID',
                                    options: {
                                        display: 'excluded',
                                        filter: false
                                    }
                                },
                                {
                                    name: 'name',
                                    label: 'Nombre',
                                    options: {
                                        customBodyRender: (value, tableMeta, updateValue) => (
                                            <span style={{fontWeight: 500}}>{value}</span>)
                                    }
                                },
                                {
                                    name: 'description',
                                    label: 'Descripción',
                                    options: {
                                        display: 'hidden'
                                    }
                                },
                                {
                                    name: 'formula',
                                    label: 'Formula'
                                },
                                {
                                    name: 'brand',
                                    label: 'Marca'
                                },
                                {
                                    name: 'price',
                                    label: 'Precio de Venta',
                                    options: {
                                        customBodyRender: (value, tableMeta, updateValue) => (
                                            <span>${value}</span>)
                                    }
                                },
                                {
                                    name: 'is_active',
                                    label: 'Estado',
                                    options: {
                                        customBodyRender: (value, tableMeta, updateValue) => {
                                            return renderStatusChip(value)
                                        }
                                    }
                                }
                            ]}
                        />
                    </Card>
                </MDBox>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
};

export default Products;
